<template>
  <div class="navbar-placeholder">
    <div class="navbar-mobile flex-row space-between">
      <BorderlessButton @click="flip">
        <Icon :type="$layout.isMenuExpanded ? 'cross' : 'burger'" width="27" height="27"/>
      </BorderlessButton>
      <BorderlessButton href="/">
        <Logo/>
      </BorderlessButton>
      <BorderlessButton href="/personal">
        <Icon type="person" width="27" height="27"/>
      </BorderlessButton>
    </div>
    <div v-if="$layout.isMenuExpanded" class="navbar-mobile-items">
      <Footer nologo/>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
import BorderlessButton from "@/components/BorderlessButton";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";

export default {
  name: 'NavbarMobile',
  components: {
    Icon,
    BorderlessButton,
    Logo,
    Footer,
  },
  data() {
    return {
    }
  },
  watch: {
    '$layout.isMenuExpanded'(value) {
      if (value)
        document.body.style.overflow = "hidden";
      else
        document.body.style.removeProperty('overflow');
    },
  },
  methods: {
    flip() {
      this.$layout.isMenuExpanded = !this.$layout.isMenuExpanded;
    },
  },
}

</script>
<style lang="scss" scoped>

.navbar-placeholder {
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
}

.navbar-mobile {
  position: fixed;
  z-index: 1;

  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #FCFCFC;
  border-bottom: 1px solid $color-2-2;

  padding: 0 30px;
}

.navbar-mobile-items {
  position: fixed;
  z-index: 1;
  top: 61px;
  left: 0;
  right: 0;
  bottom: 0px;
  background: #FCFCFC;
}

</style>
